import { useEffect, useState, useRef } from 'react';
import './supPackUpload.css';
import ReactLoading from 'react-loading';
import errorHandle from '../../../utils/errorHandle';
import { getDropdownFun } from '../../../api/infoAPI';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import BackIcon from '../../../assets/icons/trvto_ArrowBack.svg';
import DownArrow from '../../../assets/icons/down-arrow.svg';
import UpArrow from '../../../assets/icons/up-arrow.svg';
import { orgTripDetailsFun } from '../../../api/orgTripAPI';
import supPackUpSubmit from '../supPackUploadFun/supPackUpSubmit';
import { supOrgTripDetailsFun } from '../../../api/supportAdmin';
import Basic from '../../../components/supPackUploadSection/basic/Basic';
import QuickView from '../../../components/supPackUploadSection/quickView/QuickView';
import Itinerary from '../../../components/supPackUploadSection/itinerary/Itinerary';
import ImageUpOrg from '../../../components/supPackUploadSection/images/ImageUpOrg';
import InEx from '../../../components/supPackUploadSection/inEx/InEx';
import Safety from '../../../components/supPackUploadSection/safety/safety';
import ThingsToCarry from '../../../components/supPackUploadSection/thingsToCarry/thingsToCarry';
import FAQ from '../../../components/supPackUploadSection/FAQ/FAQ';
import Terms from '../../../components/supPackUploadSection/terms/Terms';
import Price from '../../../components/supPackUploadSection/price/Price';
import Tags from '../../../components/supPackUploadSection/tags/Tags';
import StaySection from '../../../components/staySection/StaySection';

export default function SupTripPackUpload() {
    const navigate = useNavigate();
    const { orgId, mode } = useParams();
    const location = useLocation();
    const submitRef = useRef(null);
    const basicRef = useRef(null);
    const quickViewRef = useRef(null);
    const itineraryRef = useRef(null);
    const imageRef = useRef(null);
    const inExRef = useRef(null);
    const safetyRef = useRef(null);
    const thingsRef = useRef(null);
    const faqRef = useRef(null);
    const termsRef = useRef(null);
    const priceRef = useRef(null);
    const tagsRef = useRef(null);
    const searchParams = new URLSearchParams(location.search);
    const [scroll, setScroll] = useState(false);
    const newPack = searchParams.get('new') === 'false';
    const type = searchParams.get('type') || 'trip';
    const tripId = searchParams.get('tripId');
    const [packData, setPackData] = useState({
        _id: '',
        status: '',
        title: '',
        overview: '',
        days: 0,
        nights: 0,
        quickView: {
            type: [],
            difficulty: '',
            startTime: '',
            endTime: '',
            duration: '',
            stay: '',
            where: '',
            food: '',
            trekDistance: '',
            baseCities: ''
        },
        itinerary: [
            {
                dayHeading: '',
                dayDescription: ''
            }
        ],
        group: '',
        itiType: '',
        datesType: '',
        FAQ: [{ question: '', answer: '' }],
        price: [
            {
                price: {
                    actual: 0,
                    get tax() {
                        return this.actual * 0.05;
                    },
                    get total() {
                        return this.actual + this.tax + this.vehicle;
                    },
                    reserve: 0
                },
                customPrice: {
                    room: 0,
                    bed: 0,
                    perPerson: 0,
                    vehicle: [],
                    reserve: 0,
                    groupPrice: 0
                },
                startCity: '',
                pickupLocation: [],
                meetupPoint: [],
                vehicle: [],
                installment: []
            }
        ],
        withoutTransportPrice: 0,
        tags: [],
        stayDetails: { name: '', location: '', mapLink: '', description: '', images: [] }
    });
    const [tempData, setTempData] = useState({
        included: '',
        excluded: '',
        terms: '',
        safety: '',
        carry: ''
    });
    const [imgData, setImgData] = useState({
        oldWallImg: [],
        oldThumbImg: [],
        newWallImg: [],
        newThumbImg: []
    });
    const [loading, setLoading] = useState(false);
    const [cityDrop, setCityDrop] = useState([
        { name: 'Bengaluru', displayName: 'Bengaluru/Bangalore' },
        { name: 'Mysuru', displayName: 'Mysuru/Mysore' }
    ]);
    const [isEdit, setIsEdit] = useState(false);
    const [videoFile, setVideoFile] = useState(null);
    const typeMap = {
        t: 'trip',
        g: 'gu',
        a: 'act',
        c: 'camp'
    };
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, []);

    // useEffect(() => {
    //     if (!location.state) return;
    //     setPackData(location.state);
    //     setImgData({
    //         oldWallImg: location.state.images,
    //         oldThumbImg: location.state.cardImages
    //     });
    //     setTempData({
    //         included: location.state.included?.join('\n'),
    //         excluded: location.state.excluded?.join('\n'),
    //         terms: location.state.terms?.join('\n'),
    //         safety: location.state.safety?.join('\n'),
    //         carry: location.state?.carry?.join('\n')
    //     });
    //     isDuplicate ? setIsEdit(false) : setIsEdit(true);
    //     //eslint-disable-next-line
    // }, [location.state]);

    useEffect(() => {
        async function getDropCity() {
            try {
                setLoading(true);
                const city = await getDropdownFun('trip', 'Base Cities');
                if (city.data) {
                    setCityDrop(city.data.dropdown);
                }
                setLoading(false);
            } catch (error) {
                errorHandle(error);
            }
        }
        getDropCity();
    }, []);

    useEffect(() => {
        if (newPack) {
            fetchPackData(tripId, type).then((data) => {
                setPackData(data);
                setImgData((prev) => ({
                    ...prev,
                    oldWallImg: data?.images,
                    oldThumbImg: data?.cardImages
                }));
                setVideoFile(data?.videos[0] || null);
                setTempData({
                    included: data?.included?.join('\n'),
                    excluded: data?.excluded?.join('\n'),
                    terms: data?.terms?.join('\n'),
                    safety: data?.safety?.join('\n'),
                    carry: data?.carry?.join('\n')
                });
                type === 'duplicate' ? setIsEdit(false) : setIsEdit(true);
                if (type === 'duplicate') {
                    setImgData({
                        oldWallImg: [],
                        oldThumbImg: [],
                        newWallImg: [],
                        newThumbImg: []
                    });
                    setVideoFile(null);
                    setPackData((prevState) => ({
                        ...prevState,
                        price: [
                            {
                                price: {
                                    actual: null,
                                    get tax() {
                                        return Math.round(this.actual * 0.05);
                                    },
                                    get total() {
                                        return Math.round(this.actual + this.tax + this.vehicle);
                                    },
                                    reserve: null,
                                    higherPrice: null,
                                    discountPer: null,
                                    room: null
                                },
                                customPrice: {
                                    room: null,
                                    bed: null,
                                    perPerson: null,
                                    vehicle: [],
                                    reserve: null,
                                    groupPrice: null
                                },
                                startCity: '',
                                pickupLocation: [],
                                meetupPoint: [],
                                vehicle: [],
                                instalments: []
                            }
                        ]
                    }));
                }
                setLoading(false);
            });
        } else {
            setLoading(false);
        }
    }, [newPack, tripId, type]);

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.scrollY;

            // Set scroll to true if user is not at top
            if (scrollTop > 3000) {
                setScroll(true);
            } else {
                setScroll(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        // Clean up on unmount
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    async function fetchPackData(id, type) {
        try {
            const result = await supOrgTripDetailsFun(id, typeMap[mode]);
            return result.data; // Return the data directly
        } catch (error) {
            errorHandle(error);
            return null;
        }
    }

    const handleSubmit = async () => {
        const res = await supPackUpSubmit(packData, tempData, imgData, setLoading, isEdit, orgId, videoFile, {
            basicRef,
            quickViewRef,
            itineraryRef,
            imageRef,
            inExRef,
            safetyRef,
            thingsRef,
            faqRef,
            termsRef,
            priceRef,
            tagsRef
        });
        if (res === 200) {
            navigate(`/support/t/packages/${orgId}`);
        }
    };
    const handleScrollToSubmit = () => {
        if (submitRef.current) {
            submitRef.current.scrollIntoView({ behavior: 'smooth' });
            setScroll(true);
        }
    };

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setScroll(false);
    };

    return (
        <>
            <div>
                <button className='backBtn' onClick={() => navigate(`/support/packages/${orgId}`)}>
                    <img src={BackIcon} alt='back' />
                    Back to Packages
                </button>
            </div>
            <div className='orgPackUpDiv'>
                {loading && (
                    <div className='loadingBackground'>
                        <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                    </div>
                )}

                <div className='sticky-containerPack'>
                    {scroll ? (
                        <button onClick={scrollToTop} title='Scroll to bottom' className='sticky-button'>
                            <img src={UpArrow} alt='scroll to bottom' />
                        </button>
                    ) : (
                        <button onClick={handleScrollToSubmit} title='Scroll to bottom' className='sticky-button'>
                            <img src={DownArrow} alt='scroll to bottom' />
                        </button>
                    )}
                </div>
                <Basic ref={basicRef} packData={packData} setPackData={setPackData} isEdit={isEdit} />
                {/* //Small bold Information which contains slots, type, difficulty, start time, end time,
        // duration, stay, where, food, trek distance */}
                <QuickView ref={quickViewRef} packData={packData} setPackData={setPackData} />
                <Itinerary ref={itineraryRef} packData={packData} setPackData={setPackData} />
                <ImageUpOrg
                    ref={imageRef}
                    imgData={imgData}
                    setImgData={setImgData}
                    isEdit={isEdit}
                    videoFile={videoFile}
                    setVideoFile={setVideoFile}
                />
                <StaySection packData={packData} setPackData={setPackData} isEdit={isEdit} />
                <InEx ref={inExRef} tempData={tempData} setTempData={setTempData} packData={packData} />
                <Safety
                    ref={safetyRef}
                    tempData={tempData}
                    setTempData={setTempData}
                    isEdit={isEdit}
                    packData={packData}
                />
                <ThingsToCarry
                    ref={thingsRef}
                    tempData={tempData}
                    setTempData={setTempData}
                    packData={packData}
                    isEdit={isEdit}
                />
                <FAQ ref={faqRef} packData={packData} setPackData={setPackData} />
                <Terms ref={termsRef} tempData={tempData} setTempData={setTempData} />
                <Price
                    ref={priceRef}
                    packData={packData}
                    setPackData={setPackData}
                    cityDrop={cityDrop}
                    isEdit={isEdit}
                />
                <Tags data={packData} setData={setPackData} />

                <button ref={submitRef} type='button' className='orgPackUpSubmitBtn blueBtn' onClick={handleSubmit}>
                    Submit
                </button>
            </div>
        </>
    );
}
